import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/denntenna.github.io/denntenna.github.io/src/components/default-mdx-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Gamak Ghar`}</h1>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "800px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/d83e960f278e6fc7a90900786cc2eab6/d00b9/gamak-ghar.webp",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.333333333333336%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/webp;base64,UklGRnIAAABXRUJQVlA4IGYAAABwAwCdASoUAAsAPtFUo0uoJKMhsAgBABoJYwC7AB43QJhleYAA/vRw3prRZ3EfCWeC4PbAcARqiSOWYu7tzIC7bMoRaC8/M9usZ+xYdkMYbDw2CBzfuG/8ZhHZDSPSCGIzNfqcAAA=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Film Poster",
            "title": "Film Poster",
            "src": "/static/d83e960f278e6fc7a90900786cc2eab6/d00b9/gamak-ghar.webp",
            "srcSet": ["/static/d83e960f278e6fc7a90900786cc2eab6/c85cb/gamak-ghar.webp 300w", "/static/d83e960f278e6fc7a90900786cc2eab6/e88ff/gamak-ghar.webp 600w", "/static/d83e960f278e6fc7a90900786cc2eab6/d00b9/gamak-ghar.webp 800w"],
            "sizes": "(max-width: 800px) 100vw, 800px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p>{`A story about a home told in three parts, across decades. It made me nostalgic of a childhood home and a time when it was very common for extended families to get together for major events. As time passes and the older members of the family pass away, the familial relationships wither away and we see the house in decay through the film.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      